export default __webpack_public_path__ + "static/media/Lasse_SoMe2_Uden_outro.93012785.mp4";